module.exports = __webpack_public_path__ + "static/media/github-orange.f26bd05d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/github-orange.svg
 ** module id = 143
 ** module chunks = 0
 **/